import { FlightSummary } from '@models/micro/flight-summary.model';
import { Passenger } from '@models/micro/passenger.model';
import { CHECKIN_STATUS } from '@app/enums';
import {
  GenericSpecialRequestInt,
  LegAWSInt,
  OldLegAWSInt,
  PNRLookupAWSInt,
  RemarksInt,
} from '@app/interfaces/reservation-aws.interface';
import { Segment } from './segment.model';
import { Mandate, Trip } from './response/viewDocuments.model';
import { getFlightStatus } from '@app/utils/functions/srIrops';
export class Reservation {
  checkinStatus: CHECKIN_STATUS;
  clid: string;
  codeShare: boolean;
  creationDate: string;
  flightItineraryType: any;
  flightSummary: FlightSummary;
  isAgencyReservation: boolean;
  isEmployee: boolean;
  isStandBy: boolean;
  oldFlightSummary: FlightSummary | undefined;
  isStandByBooking: any;
  kioskStartTime: any;
  mandates: Mandate[];
  passengers: Passenger[];
  pnr: string;
  segments: Segment[];
  iropsElegibility: boolean;
  travelPartyId: string;
  trips: Trip[];
  tripType: string;
  typeReservation: string;
  ticketTimeLimit: number;
  currency: any;
  isNewBF = false;
  hasModifyFFN = false;
  hasShownCarryOnModalMainLight?: boolean = false; // CI-19083: Control de visualización única del modal carry-on
  remarks: RemarksInt[];
  genericSpecialRequests: GenericSpecialRequestInt[];
  overWeight: any[];
  passengerNumbers: string;

  constructor(data?: {
    pnrCode: string;
    pnr: PNRLookupAWSInt;
    leg: LegAWSInt;
    oldLeg: LegAWSInt;
    kioskLocation: string;
  }) {
    if (data) {
      const { pnrCode, pnr, leg, kioskLocation, oldLeg } = data;
      const listCheckinStatus = {
        CKI: CHECKIN_STATUS.OPEN,
        CLOSED: CHECKIN_STATUS.CLOSED,
        MYB: CHECKIN_STATUS.CLOSED,
        IN_FLIGHT: CHECKIN_STATUS.CLOSED,
      };

      this.flightSummary = new FlightSummary(pnr, leg, kioskLocation);
      this.oldFlightSummary = oldLeg ? new FlightSummary(pnr, oldLeg, kioskLocation) : undefined;
      this.kioskStartTime = new Date();
      this.pnr = pnrCode;
      this.checkinStatus = this.flightSummary.checkinStatus;
      this.creationDate = pnr.creationDate;
      this.segments = this.constructSegment(leg.segments);
      this.isEmployee = pnr.isEmployee;
      this.iropsElegibility = true;
      this.isStandBy = pnr.isStandBy;
      this.codeShare = false;
      this.tripType = pnr.tripType;
      this.typeReservation = pnr.typeReservation;
      this.ticketTimeLimit = pnr.ticketTimeLimit;
      this.clid = pnr.clid;
      this.currency = pnr.currency;
      this.remarks = pnr.remarks;
      this.genericSpecialRequests = pnr.genericSpecialRequests || [];
      if (this.oldFlightSummary?.segments?.length) {
        const statusFlight = getFlightStatus(
          oldLeg.segments[0].departureDateTime,
          leg.segments[0].departureDateTime
        );
        const flightsNewInfo = {
          arrivalDateTime: this.oldFlightSummary.segments[0].arrivalDateTime,
          departureDateTime: this.oldFlightSummary.segments[0].departureDateTime,
          flightNumber: this.oldFlightSummary.segments[0].operatingFlightCode,
          status: statusFlight?.status,
        };

        this.oldFlightSummary.segments.forEach((segment) => {
          (segment as any).flightsNewInfo = flightsNewInfo;
        });
      }
      this.isNewBF = pnr.isNewBF;
      this.passengerNumbers = pnr.passengerNumbers;
    }
  }

  constructSegment(segments) {
    let arraySegments = [];

    for (const segment of segments) {
      arraySegments.push(new Segment(segment));
    }

    return arraySegments;
  }
}
